import { encodeBase64URI } from "utils";
import {
    GetDeliveryPromiseOfferRankingRequest,
    GetWaitlistSubscriptionStatusRequest,
    SubscribeToWaitlistRequest
} from "./types";
import InitialContext from 'state/static-data/InitialContext';

export const Urls = {
    GET_DELIVERY_PROMISES_OFFER_RANKING: (request: GetDeliveryPromiseOfferRankingRequest) => {
        const queryStr = JSON.stringify(request)
        const queryBase64 = encodeBase64URI(queryStr)
        return `${InitialContext.isKyanite() ? '/onemedical' : ''}/dp/retrieve/delivery-promise?query=${queryBase64}`
    },
    GET_WAITLIST_SUBSCRIPTION_STATUS: (request: GetWaitlistSubscriptionStatusRequest) => `/dashboard/getWaitlistSubscriptionStatus?${new URLSearchParams(request as any).toString()}`,
    SUBSCRIBE_TO_WAITLIST: (request: SubscribeToWaitlistRequest) => `/dashboard/subscribeToWaitlist?${new URLSearchParams(request as any).toString()}`,
}